
export default {
    computed: {
        orderStatusList(){
            return [
                {value:0,label:this.$t('fbb.inbound.draft', { defaultValue: '草稿' }),theme:'default'},
                {value:10,label:this.$t('fbb.inbound.check_pending', { defaultValue: '待审核' }),theme:'warning'},
                {value:20,label:'待处理',theme:'primary'},
                {value:30,label:'处理中',theme:'info'},
                {value:70,label:this.$t('global.common.finished', { defaultValue: '已完成' }),theme:'success'},
                {value:90,label:this.$t('global.common.canceled', { defaultValue: '已取消' }),theme:'default'},
                {value:15,label:this.$t('fbb.inbound.approval_back', { defaultValue: '审批拒回' }),theme:'error'},
            ]
        },
        getContactOrderList(){
            return [
                {value:35,label:'入库计划单'},
                {value:50,label:'销售出库计划单'},
                {value:80,label:'调拨计划'},
                {value:45,label:'销售退货计划单'},
                {value: 110, label: "中转计划"},
                // {value:25,label:'中转出库计划'},
                // {value:15,label:'中转入库计划'},
            ]
        },
        errorStatusList(){
            return [ {
                label: this.$t('fbb.inbound.error_push', { defaultValue: "推送异常" }),
                value: 0
            },{
                label: this.$t('fbb.inbound.error_attachment_push', { defaultValue: "附件推送异常" }),
                value: 11
            }, {
                label: this.$t('fbb.alloment.wms_back_fbb_error', { defaultValue: "wms回传fbb异常" }),
                value: 1
            }, {
                label: this.$t('fbb.inbound.error_complete', { defaultValue: "完成异常" }),
                value: 6
            }]
        },

    }
}
